export const downloadFile = async (fetchFunction, apiParams, fileName) => {
    try {
        const response = await fetchFunction(apiParams);

        // Check if response is a Blob or if it's a string containing CSV data
        if (response && typeof response.blob === 'function') {
            if (!response.ok) {
                const statusText = response.statusText || 'Unknown error';
                throw new Error(`Network response was not ok: ${statusText} (status: ${response.status})`);
            }

            let blob = await response.blob();

            // If the blob is empty, generate an empty CSV blob
            if (blob.size === 0) {
                console.warn('Received empty response blob; generating empty CSV');
                const emptyCsvContent = "data:text/csv;charset=utf-8,";
                blob = new Blob([emptyCsvContent], { type: 'text/csv' });
            }

            initiateDownload(blob, fileName);

        } else if (typeof response === 'string') {
            // Handle CSV response string
            const blob = new Blob([response], { type: 'text/csv' });
            initiateDownload(blob, fileName);

        } else {
            console.warn('Received invalid response; generating empty CSV');
            const emptyCsvContent = "data:text/csv;charset=utf-8,";
            const emptyBlob = new Blob([emptyCsvContent], { type: 'text/csv' });
            initiateDownload(emptyBlob, fileName);
        }

    } catch (error) {
        console.error('Error downloading file:', error.message || error);
        throw error;
    }
};

const initiateDownload = (blob, fileName) => {
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
};